/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import useStoreFormDraft from "../../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import axios from "axios";

import {
  MessageCircle,
  Check,
  X,
  RefreshCw,
  Lock,
  Info,
  MessageSquare,
  Phone,
  MessageSquareText,
  Facebook,
  PenSquare,
  AlertTriangle,
  ToggleRight,
} from "lucide-react";
import apicache from "../../../components/clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationConfirmChat({ close }) {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const dispatch = useDispatch();
  const MySwal = withReactContent(Swal);
  const [loading, setLoading] = useState(false);
  const [accessRequested, setAccessRequested] = useState(false);
  const products = useSelector((state) => state.ProductsReducer || []);
  const [isConfirmChatActive, setIsConfirmChatActive] = useState(false);
  const { t } = useTranslation();
  const [data, setData] = useStoreFormDraft(store);

  useEffect(() => {
    if (store) {

      setIsConfirmChatActive(Boolean(store.confirmChat));
    }
  }, [store]);

  const showAlert = (
    icon,
    title,
    text,
    showCancelButton = false,
    confirmButtonText = t("servicePageActivation.confirmChat.alerts.ok")
  ) => {
    return Swal.fire({
      icon,
      title,
      text,
      confirmButtonText,
      cancelButtonText: t("servicePageActivation.confirmChat.alerts.annuler"),
      showCancelButton,
      confirmButtonColor: "rgb(141, 93, 167)",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: true,
      backdrop: `
        rgba(0,0,0,0.7)
      `,
      position: "center",
      customClass: {
        popup: "swal-popup-on-top",
        backdrop: "swal-backdrop-on-top",
        container: "swal-container-on-top",
      },
      willOpen: () => {
        // Ensure this alert appears on top of everything
        document.querySelector(".swal2-container").style.zIndex = "9999999999";
      },
    });
  };

  // Add this style to ensure SweetAlert appears on top
  useEffect(() => {
    // Add CSS to make sure SweetAlert appears on top of other modals
    const style = document.createElement("style");
    style.innerHTML = `
      .swal-container-on-top {
        z-index: 9999999999 !important;
      }
      .swal-backdrop-on-top {
        background: rgba(0,0,0,0.7) !important;
      }
      .swal-popup-on-top {
        position: relative;
        box-shadow: 0 0 20px rgba(0,0,0,0.2);
      }
      body.swal2-shown {
        overflow: hidden;
      }
      body.swal2-shown > [aria-hidden="true"] {
        filter: blur(3px);
      }
    `;
    document.head.appendChild(style);

    // Add a click handler to ensure modal shows on top
    const handleDocumentClick = () => {
      const swalContainer = document.querySelector(".swal2-container");
      if (swalContainer) {
        swalContainer.style.zIndex = "9999999999";
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.head.removeChild(style);
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const handleDChange = () => {
    setData({ ...data, confirmChat: !data.confirmChat });
  };

  const handleDChange1 = () => {
    setData({ ...data, confirmChatS: !data.confirmChatS, confirmChatM: false });
  };

  const handleDChange2 = () => {
    setData({ ...data, confirmChatM: !data.confirmChatM, confirmChatS: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if we're activating or deactivating
    const isActivating = data.confirmChat;
    const isDeactivating = !data.confirmChat && isConfirmChatActive;

    if (isDeactivating) {
      // If deactivating, confirm with user
      const result = await showAlert(
        "warning",
        t("servicePageActivation.confirmChat.alerts.deactivateTitle"),
        t("servicePageActivation.confirmChat.alerts.deactivateText"),
        true,
        t("servicePageActivation.confirmChat.alerts.deactivateConfirmButton")
      );

      // If user cancels the confirmation, stop the process
      if (!result.isConfirmed) {
        // Reset toggle to previous state
        setData({ ...data, confirmChat: true });
        return;
      }
    }

    // Validate inputs if activating
    if (isActivating) {
      let missingFields = [];

      if (data.confirmChatS && !data.confrimChatNU) {
        missingFields.push(
          t("servicePageActivation.confirmChat.fields.phone")
        );
      }

      if (data.confirmChatM && !data.confrimChatN) {
        missingFields.push(
          t("servicePageActivation.confirmChat.fields.page")
        );
      }

      if (!data.confrimChatT) {
        missingFields.push(
          t("servicePageActivation.confirmChat.fields.message")
        );
      }

      if (!data.confirmChatS && !data.confirmChatM) {
        // Neither SMS nor Messenger is selected
        await showAlert(
          "warning",
          t("servicePageActivation.confirmChat.alerts.noMethodTitle"),
          t("servicePageActivation.confirmChat.alerts.noMethodText")
        );
        return;
      }

      if (missingFields.length > 0) {
        await showAlert(
          "warning",
          t("servicePageActivation.confirmChat.alerts.missingFieldsTitle"),
          `${missingFields.join("، ")}`
        );
        return;
      }
    }

    try {
      setLoading(true);

      await saveStoreDraft(doc(db, "store", data.id), store, data);
      dispatch(applyStoreDraft(store, data));

      setLoading(false);
      setIsConfirmChatActive(isActivating);

      if (isDeactivating) {
        await showAlert(
          "success",
          t("servicePageActivation.confirmChat.alerts.deactivatedSuccess")
        );
      } else if (isActivating) {
        await showAlert(
          "success",
          t("servicePageActivation.confirmChat.alerts.activatedSuccess")
        );
      } else {
        await showAlert(
          "success",
          t("servicePageActivation.confirmChat.alerts.savedSuccess")
        );
      }
      close();
      await apicache(account, products);
    } catch (error) {
      setLoading(false);

      if (isDeactivating) {
        await showAlert(
          "error",
          t("servicePageActivation.confirmChat.alerts.deactivationErrorTitle"),
          t("servicePageActivation.confirmChat.alerts.deactivationErrorText")
        );
      } else {
        await showAlert(
          "error",
          t("servicePageActivation.confirmChat.alerts.saveErrorTitle"),
          t("servicePageActivation.confirmChat.alerts.saveErrorText")
        );
      }

      console.error("Error saving ConfirmChat settings:", error);
    }
  };

  const handlePay = async () => {
    const result = await showAlert(
      "info",
      t("servicePageActivation.confirmChat.paidFeature.title"),
      t("servicePageActivation.confirmChat.paidFeature.description"),
      true,
      t("servicePageActivation.confirmChat.paidFeature.confirmButton")
    );

    if (result.isConfirmed) {
      if ((account.productMode ?? "classic") == "classic") {
        window.location.href = "/plan";
      } else {
        window.location.href = "/digital/plan";
      }
    }
  };

  // Check if feature is locked
  if (store.speakpage === false) {
    return (
      <div className="min-h-[400px] h-fit p-6">
        <div className="bg-white rounded-xl shadow-sm p-6 border border-[#fbf4ff] text-center dark:!bg-[#181819] dark:!border-[#3c3a3d]">
          <div className="py-8">
            <div className="mb-4 flex justify-center">
              <div className="w-20 h-20 bg-yellow-50 rounded-full flex items-center justify-center dark:!bg-[#2a2a2a]">
                <Lock size={36} className="text-yellow-500" />
              </div>
            </div>
            <h3 className="text-xl font-bold text-[#9e68ba] mb-3">
              {t("servicePageActivation.confirmChat.lockedTitle")}
            </h3>
            <p className="text-gray-600 dark:!text-gray-400 mb-6 max-w-md mx-auto">
              {t("servicePageActivation.confirmChat.lockedDescription")}
            </p>
            <button
              onClick={handlePay}
              className="px-5 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white rounded-lg transition-colors"
            >
              {t("servicePageActivation.confirmChat.subscribeButton")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-[400px] h-fit p-6">
      <div className="bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d] rounded-xl shadow-sm p-6 border border-[#fbf4ff]">
        <div className="mb-6">
          <h3 className="text-xl font-bold text-[#9e68ba] mb-2 flex items-center">
            <MessageCircle className="ml-2" size={20} />
            {t("servicePageActivation.confirmChat.title")}
          </h3>
          <p className="text-gray-600 dark:!text-gray-400">
            {t("servicePageActivation.confirmChat.description")}
          </p>
        </div>

        {/* Service Status Indicator */}
        <div
          className={`mb-4 p-3 rounded-lg border ${
            isConfirmChatActive
              ? "border-green-200 bg-white dark:!bg-[#181819] dark:!border-green-700"
              : "border-gray-200 bg-white dark:!bg-[#181819] dark:!border-[#3c3a3d]"
          }`}
        >
          <div className="flex items-center gap-x-2">
            <div
              className={`w-3 h-3 rounded-full mr-2 ${
                isConfirmChatActive ? "bg-green-500" : "bg-gray-400"
              }`}
            ></div>
            <span
              className={`text-sm font-medium dark:!text-gray-300 ${
                isConfirmChatActive
                  ? "text-green-700 dark:!text-green-300"
                  : "text-gray-700 dark:!text-gray-400"
              }`}
            >
              {isConfirmChatActive
                ? t("servicePageActivation.confirmChat.statusActive")
                : t("servicePageActivation.confirmChat.statusInactive")}
            </span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Main Toggle */}
          <div>
            <div className="flex justify-between items-center mb-4">
              <label className="block text-sm font-medium dark:!text-gray-300 text-[#9e68ba]">
                {t("servicePageActivation.confirmChat.enableLabel")}
              </label>
              <div
                className={`px-2 py-1 rounded-full text-xs font-medium dark:!text-gray-300 ${
                  data.confirmChat
                    ? "bg-green-100 text-green-800 dark:!bg-green-900 dark:!text-green-300"
                    : "bg-gray-100 text-gray-800 dark:!bg-[#3c3a3d] dark:!text-gray-400"
                }`}
              >
                {data.confirmChat
                  ? t("servicePageActivation.confirmChat.enabled")
                  : t("servicePageActivation.confirmChat.disabled")}
              </div>
            </div>
            <div
              className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                data.confirmChat
                  ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#181819] dark:!border-purple-700"
                  : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
              }`}
              onClick={handleDChange}
            >
              <div className="relative inline-block w-12 ml-3 align-middle select-none">
                <input
                  type="checkbox"
                  checked={data.confirmChat}
                  onChange={() => {}}
                  className="hidden"
                  id="toggle-main"
                />
                <label
                  htmlFor="toggle-main"
                  className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${
                    data.confirmChat ? "bg-purple-400" : ""
                  }`}
                >
                  <span
                    className={`block h-6 w-6 bg-white rounded-full shadow transform transition-transform duration-200 ${
                      data.confirmChat ? "-translate-x-6" : "translate-x-0"
                    }`}
                  />
                </label>
              </div>
              <div>
                <div className="flex items-center">
                  {data.confirmChat ? (
                    <MessageCircle size={18} className="ml-2 text-[#9e68ba]" />
                  ) : (
                    <X
                      size={18}
                      className="ml-2 text-gray-500 dark:!text-gray-400"
                    />
                  )}
                  <p className="font-medium dark:!text-gray-300">
                    {data.confirmChat
                      ? t("servicePageActivation.confirmChat.enabledMessage")
                      : t("servicePageActivation.confirmChat.disabledMessage")}
                  </p>
                </div>
                <p className="text-sm text-gray-500 dark:!text-gray-400 mt-1">
                  {data.confirmChat
                    ? t("servicePageActivation.confirmChat.enabledNote")
                    : t("servicePageActivation.confirmChat.disabledNote")}
                </p>
              </div>
            </div>
          </div>

          {/* Message Type Options */}
          {data.confirmChat && (
            <div className="space-y-4">
              <label className="block text-sm font-medium dark:!text-gray-300 text-[#9e68ba] mb-2">
                {t("servicePageActivation.confirmChat.methodLabel")}
              </label>

              {/* SMS Option */}
              <div
                className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                  data.confirmChatS
                    ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#181819] dark:!border-purple-700"
                    : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
                }`}
                onClick={handleDChange1}
              >
                <div className="relative inline-block w-12 ml-3 align-middle select-none">
                  <input
                    type="checkbox"
                    checked={data.confirmChatS}
                    onChange={() => {}}
                    className="hidden"
                    id="toggle-sms"
                  />
                  <label
                    htmlFor="toggle-sms"
                    className={`block overflow-hidden h-6 rounded-full bg-gray-300 cursor-pointer ${
                      data.confirmChatS ? "bg-yellow-400" : ""
                    }`}
                  >
                    <span
                      className={`block h-6 w-6 bg-white rounded-full shadow transform transition-transform duration-200 ${
                        data.confirmChatS
                          ? "rtl:-translate-x-6 ltr:translate-x-6"
                          : "translate-x-0"
                      }`}
                    />
                  </label>
                </div>
                <div className="flex items-center">
                  <Phone size={20} className="text-[#55266d] ml-2" />
                  <div>
                    <p className="font-medium dark:!text-gray-300">
                      {t("servicePageActivation.confirmChat.smsTitle")}
                    </p>
                    <p className="text-sm text-gray-500 dark:!text-gray-400">
                      {t("servicePageActivation.confirmChat.smsDescription")}
                    </p>
                  </div>
                </div>
              </div>

              {/* Messenger Option */}
              <div
                className={`p-4 rounded-lg border transition-colors cursor-pointer flex items-center ${
                  data.confirmChatM
                    ? "bg-[#fcf6ff] border-purple-200 dark:!bg-[#181819] dark:!border-purple-700"
                    : "bg-white border-gray-200 hover:bg-gray-50 dark:!bg-[#181819] dark:!border-[#3c3a3d]"
                }`}
                onClick={handleDChange2}
              >
                <div className="relative inline-block w-12 ml-3 align-middle select-none">
                  <input
                    type="checkbox"
                    checked={data.confirmChatM}
                    onChange={() => {}}
                    className="hidden"
                    id="toggle-messenger"
                  />
                  <label
                    htmlFor="toggle-messenger"
                    className={`block w-12 h-6 rounded-full cursor-pointer transition-colors ${
                      data.confirmChatM ? "bg-sky-400" : "bg-gray-300"
                    }`}
                  >
                    <span
                      className={`block h-6 w-6 bg-white rounded-full shadow transform transition-transform duration-200 ${
                        data.confirmChatM
                          ? "rtl:-translate-x-6 ltr:translate-x-6"
                          : "translate-x-0"
                      }`}
                    />
                  </label>
                </div>
                <div className="flex items-center">
                  <Facebook size={20} className="text-[#55266d] ml-2" />
                  <div>
                    <p className="font-medium dark:!text-gray-300">
                      {t("servicePageActivation.confirmChat.messengerTitle")}
                    </p>
                    <p className="text-sm text-gray-500 dark:!text-gray-400">
                      {t(
                        "servicePageActivation.confirmChat.messengerDescription"
                      )}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Phone Number Input */}
          {data.confirmChat && data.confirmChatS && (
            <div className="space-y-2">
              <label className="block text-sm font-medium dark:!text-gray-300 text-[#9e68ba]">
                {t("servicePageActivation.confirmChat.phoneLabel")}
              </label>
              <div className="relative">
                <input
                  type="text"
                  className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                  placeholder={t(
                    "servicePageActivation.confirmChat.phonePlaceholder"
                  )}
                  value={data.confrimChatNU || ""}
                  onChange={(e) =>
                    setData({ ...data, confrimChatNU: e.target.value })
                  }
                />
              </div>
              <p className="text-xs text-gray-500 dark:!text-gray-400">
                {t("servicePageActivation.confirmChat.phoneHint")}
              </p>
            </div>
          )}

          {/* Facebook Page Name */}
          {data.confirmChat && data.confirmChatM && (
            <div className="space-y-2">
              <label className="block text-sm font-medium dark:!text-gray-300 text-[#9e68ba]">
                {t("servicePageActivation.confirmChat.pageLabel")}
              </label>
              <div className="relative">
                <input
                  type="text"
                  className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                  placeholder={t(
                    "servicePageActivation.confirmChat.pagePlaceholder"
                  )}
                  value={data.confrimChatN || ""}
                  onChange={(e) =>
                    setData({ ...data, confrimChatN: e.target.value })
                  }
                />
              </div>
              <p className="text-xs text-gray-500 dark:!text-gray-400">
                {t("servicePageActivation.confirmChat.pageHint")}
              </p>
            </div>
          )}

          {/* Message Template */}
          {data.confirmChat && (
            <div className="space-y-2">
              <label className="block text-sm font-medium dark:!text-gray-300 text-[#9e68ba]">
                {t("servicePageActivation.confirmChat.templateLabel")}
              </label>
              <div className="relative">
                <textarea
                  className="w-full p-3 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-200 transition-colors min-h-[120px] dark:!bg-[#181819] dark:!border-[#3c3a3d] dark:!text-gray-300"
                  placeholder={t(
                    "servicePageActivation.confirmChat.templatePlaceholder"
                  )}
                  value={data.confrimChatT || ""}
                  onChange={(e) =>
                    setData({ ...data, confrimChatT: e.target.value })
                  }
                ></textarea>
              </div>
              <p className="text-xs text-gray-500 dark:!text-gray-400">
                {t("servicePageActivation.confirmChat.templateHint")}
              </p>
            </div>
          )}

          {/* Tips Section */}
          <div className="p-4 rounded-lg border border-yellow-100 bg-yellow-50 dark:!bg-[#181819] dark:!border-[#3c3a3d]">
            <h4 className="font-medium dark:!text-gray-300 text-lg text-yellow-800 dark:!text-yellow-300 mb-2 flex items-center">
              <Info size={18} className="ml-2" />
              {t("servicePageActivation.confirmChat.tipsTitle")}
            </h4>
            <ul className="text-sm text-gray-700 dark:!text-gray-400 space-y-2 mr-5 list-disc">
              <li>{t("servicePageActivation.confirmChat.tips.tip1")}</li>
              <li>{t("servicePageActivation.confirmChat.tips.tip2")}</li>
              <li>{t("servicePageActivation.confirmChat.tips.tip3")}</li>
              <li>{t("servicePageActivation.confirmChat.tips.tip4")}</li>
            </ul>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className={`px-6 py-3 ${
              data.confirmChat !== isConfirmChatActive
                ? data.confirmChat
                  ? "bg-[#9b59bf] hover:bg-[#814a9f]"
                  : "bg-red-500 hover:bg-red-600"
                : "bg-gray-400"
            } text-white rounded-lg transition-colors flex items-center justify-center ${
              loading ? "opacity-70 cursor-not-allowed" : ""
            }`}
          >
            {loading ? (
              <>
                <RefreshCw className="animate-spin ml-2" size={18} />
                {data.confirmChat
                  ? t("servicePageActivation.confirmChat.submit.activating")
                  : t("servicePageActivation.confirmChat.submit.deactivating")}
              </>
            ) : (
              <>
                {data.confirmChat !== isConfirmChatActive ? (
                  data.confirmChat ? (
                    <>
                      <Check className="ml-2" size={18} />
                      {t("servicePageActivation.confirmChat.submit.activate")}
                    </>
                  ) : (
                    <>
                      <X className="ml-2" size={18} />
                      {t("servicePageActivation.confirmChat.submit.deactivate")}
                    </>
                  )
                ) : (
                  <>
                    <Info className="ml-2" size={18} />
                    {t("servicePageActivation.confirmChat.submit.noChange")}
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
